class LoyaltyTabs extends window.PURELEI.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.tab?.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.selectTab.bind(this))
    })
  }

  selectTab (e) {
    e.preventDefault()

    const button = e.target.closest(this.els.tab.selector)

    this.els.tab?.elements.map((tab) =>
      tab.setAttribute('aria-pressed', tab === button),
    )
    this.els.content?.elements.map((content) =>
      content.setAttribute(
        'aria-hidden',
        content.dataset.tab !== button.dataset.target,
      ),
    )
  }
}

if (!customElements.get('loyalty-tabs')) {
  customElements.define('loyalty-tabs', LoyaltyTabs)
}
